import React from "react";
import { RiWhatsappFill } from "react-icons/ri";

export const WhatsappIcon = ({ className }) => {
  return (
    <RiWhatsappFill
      className={className}
      // style={{
      //   width: "110px",
      //   position: "fixed",
      //   right: "5%",
      //   bottom: "5%",
      //   zIndex: "11",
      // }}
    />
  );
};
